import React from 'react';

export function HelpStep({ number, title, children }) {
  return (
    <div className="flex gap-4 mb-6">
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-orange-500 text-white text-sm font-bold flex items-center justify-center mt-0.5">
        {number}
      </div>
      <div className="flex-1">
        <h3 className="font-semibold text-slate-900 mb-1.5">{title}</h3>
        <div className="text-slate-600 text-sm leading-relaxed space-y-2">
          {children}
        </div>
      </div>
    </div>
  );
}
